﻿'use strict'

import config from '../../common/config';

export default (function () {
    var API = {
        replaceAll: function (find, replace, str) {
            return str.replace(new RegExp(find, 'g'), replace)
        },
        changeCharactorBack : function(text) {
            if (text.length > 0) {
                text = this.replaceAll('&#38;','&', text);
                text = this.replaceAll("&#39;", "'", text);
                text = this.replaceAll('&#34;', '"', text);
                text = this.replaceAll('&#8629;', '\n', text);
            }
            return text;
        }
    };

    return API;
})();



